'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgDropUp(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("path", { d: "M2.495 8.957l4.329-4.23a1.692 1.692 0 012.356 0l4.329 4.23c1.053 1.03.3 2.793-1.187 2.793H3.665c-1.487 0-2.222-1.764-1.17-2.793z", fill: "currentColor", fillRule: "evenodd" })));
}

module.exports = SvgDropUp;
//# sourceMappingURL=DropUp.js.map
